import ViewOff16 from '@carbon/icons-react/es/view--off/16';
import View16 from '@carbon/icons-react/es/view/16';
import { Col, FormInstance, Row } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { CustomDueDatePicker } from 'components/atoms/due-date-picker';
import { Form } from 'components/atoms/form';
import { TextArea } from 'components/atoms/input';
import { useTranslation } from 'hooks/use-translation';

const SpacedFormItem = styled(Form.Item)`
  margin-left: calc(-1 * var(--layout-01));

  .ant-form-item-label {
    padding-left: var(--layout-01);
  }
`;

export const ProjectPhaseForm: FC<{
  form: FormInstance<any>;
  isEdit: boolean;
  onValuesChange(changedValues: any, values: unknown): void;
}> = ({ form, isEdit, onValuesChange }) => {
  const [isPrivate, setIsPrivate] = useState(false);

  const projectPhaseNamePlaceholder = useTranslation(
    isEdit
      ? 'projects.phase.name.edit.placeholder'
      : 'projects.phase.name.create.placeholder',
  );

  useEffect(() => {
    setIsPrivate(form.getFieldValue('private'));
  }, [form]);

  const toggleIsPrivate = () => {
    const privateValue = !isPrivate;

    setIsPrivate(privateValue);
    form.setFieldsValue({
      private: privateValue,
    });

    onValuesChange(form.getFieldValue('private'), form.getFieldsValue());
  };

  const handleDueDateChange = (range) => {
    let dateRange = range;

    if (range[0] == null && range[1] == null) {
      dateRange = null;
    }
    form.setFieldsValue({
      dateRange,
    });

    if ((range[0] != null && range[1] != null) || dateRange == null) {
      onValuesChange(form.getFieldValue('dateRange'), form.getFieldsValue());
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      preserve={false}
      onValuesChange={onValuesChange}
    >
      <Form.Item
        name="projectPhaseName"
        label={useTranslation('projects.phase.name.label')}
      >
        <TextArea
          autoFocus
          placeholder={projectPhaseNamePlaceholder}
          autoSize={{ minRows: 1, maxRows: 6 }}
        />
      </Form.Item>
      <Row>
        <Col span={12}>
          <SpacedFormItem
            name="dateRange"
            label={useTranslation('projects.phase.date')}
            required
          >
            <CustomDueDatePicker
              isRangePicker
              disallowSingleDate
              startDate={
                form.getFieldValue('dateRange')
                  ? form.getFieldValue('dateRange')[0]
                  : undefined
              }
              dueDate={
                form.getFieldValue('dateRange')
                  ? form.getFieldValue('dateRange')[1]
                  : undefined
              }
              onDateChange={handleDueDateChange}
            />
          </SpacedFormItem>
        </Col>
        <Col span={12}>
          <SpacedFormItem
            name="private"
            label={useTranslation('type')}
            required
          >
            <Button
              icon={isPrivate ? <ViewOff16 /> : <View16 />}
              type="text"
              onClick={toggleIsPrivate}
            >
              <FormattedMessage id={isPrivate ? 'private' : 'public'} />
            </Button>
          </SpacedFormItem>
        </Col>
      </Row>
    </Form>
  );
};
